const spacing = 8;
const borderRadius = 4;
const boxShadow = {
    dp1: '0 1px 2px 0 rgba(209, 209, 209, 0.5)',
    dp2: '0 3px 6px 0 rgba(209, 209, 209, 0.5)'
};

const headingTypography = {
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
};

const deviceUnits = {
    small: 599,
    medium: 959,
    large: 1115,
    xlarge: 1290
};

const devices = {
    small: `@media (max-width: ${deviceUnits.small}px)`,
    medium: `@media (max-width: ${deviceUnits.medium}px)`,
    large: `@media (max-width: ${deviceUnits.large}px)`,
    xlarge: `@media (min-width: ${deviceUnits.xlarge}px)`,
    gtSmallSmMedium: `@media (min-width: ${deviceUnits.small + 1}px) and (max-width: ${deviceUnits.large}px)`,

    units: deviceUnits,

    custom (min, max) {
        return `@media (min-width: ${min}px) and (max-width: ${max}px)`;
    },

    customMax (size) {
        return `@media (max-width: ${size}px)`;
    },
};

const hoverEffects = {
    connectButton: {
        opacity: '0.8'
    }
};

const palette = {
    textLight: '#3a3c4e',
    green: '#52d3a9',
    yellow: '#fdca00',
    border: '#ebebeb',
    white: 'white',
    darkPurple: '#240649',
    primary: '#5771dc',
    hoveredTextColor: 'white',
    channelSelectorHover: 'rgba(36, 6, 73, 0.1)',
    channelSelectorTypoDark: 'black',
    channelSelectorTypoLight: 'white',
};

const fontFamily = `'proxima-nova', sans-serif`;
const fontWeightLight = 300;
const fontWeightRegular = 400;
const fontWeightMedium = 500;
const textFontSize = 14;
const tableHeaderFontSize = 16;

const theme = {
    hoverEffects,
    spacing,
    borderRadius,
    boxShadow: boxShadow.dp1,
    boxShadowDp2: boxShadow.dp2,
    devices,
    typography: {
        fontFamily: fontFamily,
        statisticBox: {},
        tableHeader: {
            fontFamily: fontFamily,
            fontSize: tableHeaderFontSize,
            fontWeight: 500,
            letterSpacing: '0.5px',
        },
        tableRowKey: {},
        tableRowAmount: {},
        link: {
            fontSize: 12,
            borderRadius: borderRadius / 2
        },
        h1: {
            ...headingTypography,
            fontSize: 28,
            marginBottom: spacing * 1.5 // 12px
        },
        h2: {
            ...headingTypography,
            fontSize: 24,
            marginBottom: spacing,
            letterSpacing: '0.7px',
        },
        h3: {
            ...headingTypography,
            fontSize: 16,
            marginBottom: 6,
            color: palette.textLight
        },
        text: {
            fontSize: 14,
            letterSpacing: '0.4px'
        },
        bannerTitle: {
            fontSize: '40px',
            fontWeight: '500',
            lineHeight: '1.1',
            letterSpacing: '2.2px',
            [devices.small]: {
                fontSize: '30px',
            },
        },
        bannerDescription: {
            marginTop: '5px',
            fontSize: '17px',
            fontWeight: '300',
            textAlign: 'center',
            textShadow: '0 3px 3px rgba(0, 0, 0, 0.5)',
            opacity: '0.6',
        },
        buttonText: {
            color: 'white',
            letterSpacing: '2.4px',
            fontSize: '16px',
        },
    },
    palette,
    backgrounds: {
        card: 'white',
        table: 'white',
        page: '#f5f6f8',
        highlight: '#f7f7f7',
    },
    card: {
        borderRadius,
        backgroundColor: '#ffffff',
        boxShadow: boxShadow.dp1
    },
    pages: {
        maxWidth: 1290,
    },
    channelItems: {
        icon: {
            width: 65,
            height: 65,
        },
        emotesBar: {
            height: 60,
        },
        totalMessages: {},
        tables: {
            rowHeight: 46.5,
        }
    },
    tables: {
        width: `calc(33.333% - ${spacing / 1.5}px)`,
        maxWidth: `calc(33.333% - ${spacing / 1.5}px)`,
        minWidth: 270,
        maxHeight: 480,
        minHeight: 480,

        small: {
            width: '100%',
            minWidth: 320,
            maxWidth: 475,
            notExpanded: {
                maxHeight: 0,
                minHeight: 0,
            }
        },

        large: {
            width: `calc(50% - ${spacing / 1.5}px)`
        }
    }
};
export default theme;



// WEBPACK FOOTER //
// ./src/app/theme.js